export default __webpack_public_path__ + "static/media/invoice.682e67d0.jpg";